import { css } from '@emotion/react'

const svgButton = () => css`
  svg {
    width: 15px;
    height: 15px;
    margin-top: 5px;
  }
`

export const styles = {
  svgButton,
}
